import { createContext, useContext } from 'react';
import { TRACK_3D_ELEVATION } from '../../utils/layout3d';

/**
 * Rail plane for the scene currently being rendered.
 *
 * Rails and the tools beneath them are placed by separate components, so the
 * height that keeps the rail clear of the tallest tool is resolved once for the
 * whole layout and read from here.
 */
export const RailElevationContext = createContext<number>(TRACK_3D_ELEVATION);

export function useRailElevation(): number {
  return useContext(RailElevationContext);
}
